// A two-factor step-up on its own (POST /me/2fa/step-up): a current authenticator or recovery code,
// so the next ten minutes count as a fresh second factor for what asks for one (restarting the
// agents, an owner's reset, choosing someone's roles).
import { client } from '../api.ts';

export async function stepUpWith(code: string): Promise<{ ok: true } | { ok: false; message: string }> {
  const csrf = (await client.session())?.csrf;
  const res = await fetch('/me/2fa/step-up', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'content-type': 'application/json', ...(csrf ? { 'x-flow-csrf': csrf } : {}) },
    body: JSON.stringify({ code: code.trim() }),
  });
  const body = (await res.json().catch(() => null)) as { ok?: boolean; error?: { message: string } } | null;
  return res.ok && body?.ok
    ? { ok: true }
    : { ok: false, message: body?.error?.message ?? 'That code didn’t work. Try again.' };
}
